import {combineReducers} from "@reduxjs/toolkit";
import OperatorInformationReduxSlice from "../new-slices/operator-information";
import CustomerInformationReduxSlice from "../new-slices/customer-information";
import VendorInformationReduxSlice from "../new-slices/vendor-information";
import DialogsReduxSlice from "../new-slices/dialogs";
import reduxStoreDialogsSlice from "../slices/dialogs/slice";
import reduxStoreDialogSlice from "../slices/dialogs/slice";
import reduxStoreVendorProfileSlice from "../slices/vendor-profile/slice";


/**
 * The Root Reducer of the Redux Store state.
 */
const ReduxRootReducer = combineReducers({
    // old slices
    [reduxStoreDialogsSlice.name]: reduxStoreDialogSlice.reducer,
    [reduxStoreVendorProfileSlice.name]: reduxStoreVendorProfileSlice.reducer,
    // new slices.
    [OperatorInformationReduxSlice.name]: OperatorInformationReduxSlice.reducer,
    [CustomerInformationReduxSlice.name]: CustomerInformationReduxSlice.reducer,
    [VendorInformationReduxSlice.name]: VendorInformationReduxSlice.reducer,
    [DialogsReduxSlice.name]: DialogsReduxSlice.reducer,
});

export default ReduxRootReducer;
